import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {assetPath} from "@/shared/utils/asset-path";

interface HeroMarkerProps {
    text: string;
}

export function HeroMarker({text}: HeroMarkerProps): JSX.Element {
    return (
        <div className="hero__marker">
            <SmartImage src={assetPath("/images/icons/info.svg")} alt="" width={16} height={16} className="hero__marker-icon" />
            <span className="hero__marker-text">{text}</span>
        </div>
    );
}
